import { extractSanityFileIdentity } from './dotlottie-identity';
import { getRemoteDotLottieUri } from './lottie-source';
import { LottieSourceResult, UseLottieSourceOptions } from './use-lottie-source.types';

export const useLottieSource = ({ source }: UseLottieSourceOptions): LottieSourceResult => {
  const remoteDotLottieUri = getRemoteDotLottieUri(source);
  let assetIdentifier: string | undefined;

  if (remoteDotLottieUri) {
    try {
      assetIdentifier = extractSanityFileIdentity(remoteDotLottieUri);
    } catch {
      assetIdentifier = undefined;
    }
  }

  return {
    source,
    isPreparing: false,
    preparationMode: 'uri',
    assetIdentifier,
    retryCount: 0,
  };
};

export type {
  LottieSource,
  LottieSourceResult,
  LottieSurface,
  UseLottieSourceOptions,
} from './use-lottie-source.types';
